import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'
import { TmByocBandwidthUCTrunkingNotSupported } from '@/core/error/transport/TmByocBandwidthUCTrunkingNotSupported'

export const byocBandwidthUCTrunkingNotSupported: CustomErrorRule = {
  endpoint: EndpointsEnum.byocCarrierIndex,
  subCodes: ['byoc.bandwidth.uc_trunking_not_supported'],
  klass: TmByocBandwidthUCTrunkingNotSupported,
}
